/** @jsxImportSource @emotion/react */
import React from "react";
import ReactModal from "react-modal";
import switchNetworkIcon from "../../../../img/icon-switch_network.svg";
import { NetworkRow } from "./NetworkRow";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { MODAL_SELECTORS } from "../modalSelectors";
import { ModalContent } from "../../../general/ModalContent/ModalContent";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useNetworkButtonConfig } from "hooks/useNetworkButtonConfig";

export const SwitchNetwork: React.FC = props => {
  const modalSelector = GlobalStore.useState(s => s.modalSelector);
  const theme = GlobalStore.useState(s => s.theme);
  const networkButtonConfig = useNetworkButtonConfig();

  return (
    <>
      <ReactModal
        isOpen={modalSelector === MODAL_SELECTORS.SWITCH_NETWORK}
        className={`react-modal`}
        style={{
          content: {
            margin: "0 auto",
          },
        }}
      >
        <ModalContentContainer className={`new-skin modal-dialog modal-dialog-centered m-frame`}>
          <ModalContent backgroundColor="alt">
            <div className={`modal-body`}>
              <div className="d-flex justify-content-between">
                <h5 className="modal-h5">Switch Network</h5>
              </div>
              <div className="sp12"></div>
              <div className="text-center">
                <img src={switchNetworkIcon} alt="Switch network" />
              </div>
              <div className="sp28"></div>
              <p
                className="text-center"
                css={css`
                  width: 270px;
                  text-align: center;
                  margin: 0 auto;
                  font-family: ${theme.fontFamilies.Primary};
                  font-weight: ${theme.fontWeights["work-sans-2"]};
                `}
              >
                To use Bebop please switch to a supported network
              </p>
              <div className="sp20"></div>
              {Object.entries(networkButtonConfig).map(([network, props]) => {
                const Icon = props.icon;
                return (
                  <span key={network}>
                    <NetworkRow
                      networkName={network}
                      icon={<Icon width={22} height={22} color={props.backgroundColor} />}
                      networkId={props.id}
                    />
                    <div className="sp10"></div>
                  </span>
                );
              })}
            </div>
          </ModalContent>
        </ModalContentContainer>
      </ReactModal>
    </>
  );
};

// Sub-components

const ModalContentContainer = styled.div`
  margin: auto;
  width: 450px;
`;
